import React from 'react';

const P404 = () => (
  <h1>404</h1>
);

export default P404;
